// src/components/Product/SuccessDialog.js
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import { Close, CheckCircle } from '@mui/icons-material';

const SuccessDialog = ({
  open,
  onClose,
  productImage,
  productName,
  onViewCart,
  onContinueShopping
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm" 
      fullWidth
      sx={{ 
        '& .MuiDialog-paper': { 
          borderRadius: 3,
          direction: 'rtl'
        } 
      }}
    >
      {/* Custom Dialog Header with Close Button */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        p: 2
      }}>
        <IconButton 
          onClick={onClose}
          sx={{ 
            color: '#666',
            '&:hover': { bgcolor: '#f5f5f5' }
          }}
        >
          <Close />
        </IconButton>
      </Box>
      
      <DialogContent sx={{ textAlign: 'center', py: 1 }}>
        {/* Product image with green check mark */}
        <Box sx={{ 
          position: 'relative', 
          display: 'inline-block', 
          mb: 3 
        }}>
          <Box sx={{
            width: 100,
            height: 100,
            borderRadius: 2,
            overflow: 'hidden',
            display: 'inline-block'
          }}>
            <img
              src={productImage}
              alt={productName}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Box>
          <CheckCircle 
            sx={{ 
              position: 'absolute',
              top: -8,
              right: -8,
              fontSize: 32,
              color: '#4caf50',
              bgcolor: '#fff',
              borderRadius: '50%'
            }} 
          />
        </Box>
        
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 'bold',
            color: '#333',
            mb: 4
          }}
        >
          لقد تم اضافة المنتج بنجاح
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ 
        flexDirection: 'column', 
        gap: 2, 
        p: 3, 
        pt: 0 
      }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={onViewCart}
          sx={{
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            backgroundColor: '#0f3662',
            borderRadius: 2,
            '&:hover': { 
              backgroundColor: '#0a2a4a'
            }
          }}
        >
          إظهار سلة المشتريات
        </Button>
        
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={onContinueShopping}
          sx={{
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
            borderColor: '#0f3662',
            color: '#0f3662',
            borderRadius: 2,
            '&:hover': {
              borderColor: '#0f3662',
              backgroundColor: 'rgba(15, 54, 98, 0.04)'
            }
          }}
        >
          متابعة التسوق
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;